import { api } from "./axios";

export interface CarouselPendingSwap {
  from: number;
  to: number;
  checks_remaining: number;
}

export interface CarouselUpstreamSnapshot {
  interface_up: boolean;
  last_success: string | null;
  last_latency_ms: number | null;
  last_error: string | null;
  last_check_at: string | null;
}

export interface CarouselStatus {
  active_set: {
    ids: number[];
    pending_swap: CarouselPendingSwap | null;
  };
  last_fast_check_at: string | null;
  last_slow_check_at: string | null;
  upstreams: Record<string, CarouselUpstreamSnapshot>;
}

export const fetchCarouselStatus = () =>
  api.get<CarouselStatus>("/api/admin/carousel/status");

export const forceCarouselFallback = () =>
  api.post<{ success: boolean; error?: string }>(
    "/api/admin/carousel/force-fallback"
  );
